import React, { Component } from 'react';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import { push } from 'connected-react-router';
import { getP, PropType as PolygotPropType } from 'redux-polyglot';
import PropTypes from 'prop-types';
import {
  Route, Switch, Redirect,
} from 'react-router-dom';
import { Radio } from 'antd';
import momentPropTypes from 'react-moment-proptypes';
import { updateDateRange } from 'actions/daterange';
import { updateOrganizationContext } from 'actions/organization';
import {
  getOrganizations, getLocations, getSites, getZones,
} from 'actions/inventory';
import DateSelect from 'components/DateRangePicker';
import OrgSelect from 'components/OrgSelect';

import Historical from './Historical';
import RealTime from './RealTime';

class AirportSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      superUser: false,
    };
  }

  componentDidMount() {
    const { dispatch, superuser } = this.props;
    if (superuser) {
      dispatch(getOrganizations());
    }
  }

  @autobind
  handlePage(e) {
    const { dispatch } = this.props;
    if (e.target.value === 'summary') {
      return dispatch(push('/analytics/summary'));
    }
    return dispatch(push('/analytics/summary/historical'));
  }

  @autobind
  handleDateChange({ startDate, endDate }) {
    const { dispatch } = this.props;
    dispatch(updateDateRange(startDate, endDate));
  }

  @autobind
  handleOrgSelect(org) {
    const { dispatch } = this.props;
    dispatch(getLocations(org));
    dispatch(getSites(org));
    dispatch(getZones(org));
    dispatch(updateOrganizationContext(org));
    this.setState({ superUser: false });
  }

  @autobind
  handleOrgVisible(superUser) {
    this.setState({ superUser });
  }

  render() {
    const {
      p, startDate, endDate, orgId, location, zones, token, isOrgAdmin,
      superuser, orgContext, organizations,
    } = this.props;
    const { superUser } = this.state;
    const summaryProps = {
      p, startDate, endDate, orgId, zones, token, isOrgAdmin,
    };
    const tab = location.pathname.split('/').pop();
    return (
      <div className="summary-layout airport-summary">
        <div className="summary-header">
          <div className="title">
            {p.tt('navigation.summary')}
            {tab === 'summary' && (
              <small style={{ fontSize: 11 }}>
                {p.t('airport_summary.past_hour')}
              </small>
            )}
          </div>
          {superuser && (
            <div>
              <OrgSelect
                p={p}
                onChange={this.handleOrgSelect}
                value={orgContext}
                visible={superUser}
                handleVisible={this.handleOrgVisible}
                organizations={organizations.data || []}
              />
            </div>
          )}
          <div className="summary-page-selector">
            <Radio.Group className="summary" value={tab} onChange={this.handlePage}>
              <Radio.Button value="summary">{p.tt('right_now')}</Radio.Button>
              <Radio.Button value="historical">{p.tt('summary.historically')}</Radio.Button>
            </Radio.Group>
          </div>
          <div style={{ visibility: tab === 'summary' && 'hidden' }}>
            <DateSelect
              p={p}
              startDate={startDate}
              endDate={endDate}
              onChange={this.handleDateChange}
            />
          </div>
        </div>
        <Switch>
          <Route path="/analytics/summary/historical" render={props => <Historical {...props} {...summaryProps} />} />
          <Route path="/analytics/summary" render={props => <RealTime {...props} {...summaryProps} />} />
          <Redirect to="/analytics/summary" />
        </Switch>
      </div>
    );
  }
}

AirportSummary.propTypes = {
  p: PolygotPropType,
  dispatch: PropTypes.func,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  orgId: PropTypes.number,
  token: PropTypes.string,
  zones: PropTypes.object,
};

export default connect(state => ({
  p: getP(state),
  startDate: state.dateRange.startDate,
  endDate: state.dateRange.endDate,
  orgId: state.currentUser.organization.id === 1
    ? state.orgContext.orgId : state.currentUser.organization.id,
  zones: state.zones,
  isOrgAdmin: state.currentUser.profile.role.is_admin,
  superuser: state.currentUser.organization ? state.currentUser.organization.id === 1 : false,
  orgContext: state.orgContext.orgId || 1,
  organizations: state.organizations,
}))(AirportSummary);
